import type { Metadata, TrackJSMod } from "./types"

import { createContext, useContext } from "react"

type TrackJsContextType = { getMetadata?: () => Metadata; trackJS: TrackJSMod | null }

export const TrackJsContext = createContext<TrackJsContextType>({ trackJS: null })

export const useTrackJs = (): TrackJSMod | null => {
  const { trackJS } = useContext(TrackJsContext)

  return trackJS
}
